import Account from "./Account";
import Actions, { ActionForm } from "./Actions";
import Admin from "./Admin";
import Budget from "./Budget";
import BudgetForm from "./Budget/BudgetForm";
// import Admin from "./Admin";
import Company from "./Company";
import FormCompany from "./Company/FormCompany";
import Extract from "./Extract";
import Home from "./Home";
import Info from "./Info";
import Profile from "./Profile";
import FormProfile from "./Profile/FormProfile";
import Reports from "./Reports";
import Users from "./Users";
import FormUser from "./Users/FormUser";

interface IRouteItem{
  path: string; 
  page: () => JSX.Element;
  error?: boolean;
  permission?: string;
  permission_by_user?: string;
}

const RoutesList: IRouteItem[] = [
  {path:"/", page:Home},
  {path:"/account", page:Account},
  
  // ACTION
  {path:"/action", page:Actions, permission:"action.index"},
  {path:"/action/create", page:ActionForm, permission:"action.index.create"},
  {path:"/action/show/:id", page:ActionForm, permission:"action.index.view"},
  {path:"/action/edit/:id", page:ActionForm, permission:"action.index.update"},

  // EXTRACT
  {path:"/extract", page:Extract, permission:"extract"},

  // COMPANY
  {path:"/company", page:Company, permission:"company.index"},
  {path:"/company/create", page:FormCompany, permission:"company.create"},
  {path:"/company/show/:id", page:FormCompany, permission:"company.view"},
  {path:"/company/edit/:id", page:FormCompany, permission:"company.update"},

  // BUDGET
  {path:"/budget", page:Budget, permission:"budget.index"},
  {path:"/budget/create", page:BudgetForm, permission:"budget.create"},

  //INFOS
  {path:"/infos", page:Info, permission:"info.index"},

  // ADMIN
  {path:"/admin", page:Admin, permission_by_user: "robson@trend2b.com"},
  
  // USER
  {path:"/admin/user", page:Users, permission:"admin.user.index"},
  {path:"/admin/user/create", page:FormUser, permission:"admin.user.create"},
  {path:"/admin/user/show/:id", page:FormUser, permission:"admin.user.view"},
  {path:"/admin/user/edit/:id", page:FormUser, permission:"admin.user.update"},

  // PROFILE
  {path:"/admin/profile", page:Profile, permission:"admin.profile.index"},
  {path:"/admin/profile/create", page:FormProfile, permission:"admin.profile.create"},
  {path:"/admin/profile/show/:id", page:FormProfile, permission:"admin.profile.view"},
  {path:"/admin/profile/edit/:id", page:FormProfile, permission:"admin.profile.update"},

  {path:"/reports", page:Reports},
]
export default RoutesList;